import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-bees-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './bees-footer.component.html',
  styleUrl: './bees-footer.component.scss'
})
export class BeesFooterComponent {

}
